import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AdminSetup() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) { setError('Passwörter stimmen nicht überein'); return; }
    if (form.password.length < 8) { setError('Passwort muss mindestens 8 Zeichen haben'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/admin/setup`, { name: form.name, email: form.email, password: form.password, role: 'admin' });
      navigate('/admin/login');
    } catch (err) {
      setError(err.response?.data?.detail || 'Einrichtung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#020817] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <span className="text-2xl font-extrabold text-white uppercase" style={{ fontFamily: 'Outfit, sans-serif' }}>Hosting-</span>
          <span className="text-2xl font-extrabold text-cyan-400 uppercase" style={{ fontFamily: 'Outfit, sans-serif' }}> Community</span>
          <p className="text-sm text-slate-500 mt-2">Ersteinrichtung</p>
        </div>

        <form onSubmit={handleSubmit} data-testid="setup-form"
          className="bg-[#0f172a] border border-slate-800 rounded-2xl p-8 space-y-4">
          <div>
            <h1 className="text-xl font-bold text-white">Admin-Konto erstellen</h1>
            <p className="text-xs text-slate-500 mt-1">Dieses Konto erhält vollen Zugriff auf den Admin-Bereich.</p>
          </div>

          {error && <div className="px-4 py-2.5 bg-red-500/10 border border-red-500/30 rounded-lg text-sm text-red-400">{error}</div>}

          {[
            { key: 'name', label: 'Name', type: 'text', placeholder: 'Max Mustermann' },
            { key: 'email', label: 'E-Mail', type: 'email', placeholder: 'admin@hosting-community.de' },
            { key: 'password', label: 'Passwort', type: 'password', placeholder: 'Min. 8 Zeichen' },
            { key: 'confirm', label: 'Passwort bestätigen', type: 'password', placeholder: '••••••••' },
          ].map(({ key, label, type, placeholder }) => (
            <div key={key} className="space-y-1">
              <label className="text-xs font-medium text-slate-400 uppercase tracking-wider">{label}</label>
              <input type={type} value={form[key]} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                required placeholder={placeholder} data-testid={`setup-${key}`}
                className="w-full px-4 py-2.5 bg-slate-800 border border-slate-700 rounded-lg text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 transition-colors" />
            </div>
          ))}

          <button type="submit" disabled={loading} data-testid="setup-submit"
            className="w-full py-2.5 bg-cyan-500 text-slate-950 font-semibold rounded-lg hover:bg-cyan-400 transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            Admin-Konto erstellen
          </button>
        </form>
      </div>
    </div>
  );
}
